import { Injectable } from '@angular/core';

import { ignoreElementsTyped } from '@frontend/sports/common/core/utils/rxjs';
import { popupManualClose } from '@frontend/sports/modal/feature';
import { ModelPopupTypes } from '@frontend/sports/navigation/core/feature/url-helper';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { betslipTypesBaseSelector } from 'packages/sports/common/betslip/modules/types/base/selectors';
import { PopupManager } from 'packages/sports/web/app/src/popup/popup-manager.service';
import { filter, map } from 'rxjs';

import { MyBetsTrackingConstants } from '../models';
import { MyBetsTrackingService } from '../services/my-bets-tracking.service';

@Injectable()
export class MyBetsTrackingEffects {
    constructor(
        protected actions$: Actions,
        protected store: Store,
        protected popupManagerService: PopupManager,
        protected myBetsTrackingService: MyBetsTrackingService,
    ) {}

    handleManualClosePopup$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(popupManualClose),
                filter((_) => this.popupManagerService.currentPopup === ModelPopupTypes.MyBets),
                concatLatestFrom(() => this.store.select(betslipTypesBaseSelector)),
                map(() => {
                    return this.myBetsTrackingService.trackMyBetsCTAClose({
                        action: MyBetsTrackingConstants.Close,
                    });
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );
}
